<template>
  <div class="container pickup-point-single">
    <div class="container">
      <Title type="news-single" class="pickup-point-single_title">
        {{ pageTitle }}
      </Title>
      <div class="pickup-point-single_description">
        <div v-if="single.metro" class="pickup-point-single_field pickup-point-single_field__metro">
          {{ single.metro }}
        </div>
        <a
          v-if="single.workPhone"
          :href="`tel:${single.workPhone}`"
          class="pickup-point-single_field pickup-point-single_field__phone"
        >
          {{ single.workPhone }}
        </a>
        <div v-if="single.startTime && single.endTime" class="pickup-point-single_field pickup-point-single_field__time">
          с {{ single.startTime }} до {{ single.endTime }}
        </div>
      </div>
    </div>

    <Masonry class="pickup-point-single_menu" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '~/components/UI/Title.vue'
import Masonry from '~/components/page/MasonryGrid.vue'

export default {
  components: { Masonry, Title },
  data () {
    return {
      single: {},
    }
  },
  computed: {
    ...mapGetters({
      pageTitle: 'seo/getPageTitle',
    }),
  },
  async asyncData ({ $axios, store, route, error }) {
    const slug = route.params.slug

    try {
      const single = await store.dispatch('info/fetchPickupPointBySlug', slug)

      /** Set default meta tags */
      store.commit('seo/setMetaFieldsDefaults', {
        metaTitle: `${single.address} — суши и роллы ${store.getters['region/getCurRegionNamePadeg']} | СУШИСЕТ`,
        metaDescription: `Суши и роллы в ресторане СУШИСЕТ по адресу: ${single.city}, ${single.address}. Заказывайте вкусную японскую еду у нас!`,
        pageTitle: [single.city, single.address].join(', '),
      })

      return {
        single,
      }
    } catch (err) {
      return error({ statusCode: 404, message: 'Продукт не найден' })
    }
  },
}
</script>

<style lang="less">
.pickup-point-single {
  padding-bottom: 40px;
  &_title {
    margin-bottom: 10px;
  }

  &_description {
    margin-bottom: 40px;
  }

  &_field {
    margin-bottom: 10px;

    &__phone {
      display: block;
      font-weight: 500;
      font-size: 18px;
      text-decoration: none;
      color: #000;
    }

    &__time {
      //font-size: 12px;
    }
  }
}
</style>
